export const FILTER_CHIP_CLASS =
  'inline-flex items-center min-h-[44px] lg:min-h-0 px-3 py-1.5 lg:px-2.5 lg:py-1 rounded-full text-sm lg:text-[13px] border transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-chocolate focus-visible:ring-offset-2';
export const FILTER_CHIP_ACTIVE_CLASS = 'bg-champagne border-chocolate text-chocolate-dark font-medium';
export const FILTER_CHIP_INACTIVE_CLASS =
  'border-champagne-dark text-text-medium hover:border-chocolate/60 hover:text-text-dark';
